// src/pages/InformeComisionesDetalle.jsx

import React from "react";
import ReporteComisionesDetalle from "../components/ReporteComisionesDetalle";

const InformeComisionesDetalle = () => {
  return (
    <>
      <ReporteComisionesDetalle />
    </>
  );
};

export default InformeComisionesDetalle;